import { ref as r } from "vue";
import { useWindowEvent as e } from "./index549.js";
var s = ((a) => (a[a.Forwards = 0] = "Forwards", a[a.Backwards = 1] = "Backwards", a))(s || {});
function n() {
  let a = r(0);
  return e("keydown", (o) => {
    o.key === "Tab" && (a.value = o.shiftKey ? 1 : 0);
  }), a;
}
export {
  s as Direction,
  n as useTabDirection
};
